export default __webpack_public_path__ + "static/media/white-pencil-icon.013a0bc4.svg";